import {Contributor} from '@/model/src/values/dv-11';
import {DomainValueReference} from '@/model/types';
import {InvestorAccount} from '@/types/client-info';

export const mapAccountSpousalFlagToDomainValue = (
  spousalFlag: InvestorAccount['spousalFlag'] | undefined,
): DomainValueReference | null => {
  if (spousalFlag === 'Y') return {$ref: Contributor.SPOUSAL};
  if (spousalFlag === 'N') return {$ref: Contributor.CONTRACTHOLDER};
  return null;
};
